import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function GeneratingTokensIcon(props: IconProps) {
    return <Icon {...props} iconKey={"generating_tokens"}/>
}
